const root = window.Shopify?.routes?.root || '/';
let busy = false;
const signature = properties => JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
const originalLine = (item, operation) => Number(item.variant_id) === Number(operation.oldVariant) && (item.key === operation.oldKey || (operation.oldCustomId && item.properties?.['_Customization ID'] === operation.oldCustomId) || signature(item.properties) === operation.oldSignature);
const request = async (path, body) => {
  const response = await fetch(`${root}${path}`, { headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : { cache: 'no-store' }) });
  if (!response.ok) throw new Error('Cart request failed');
  return response.json();
};
const checkout = () => Array.from(document.querySelectorAll('button[name="checkout"], input[name="checkout"], [href$="/checkout"]'));
const disabledBeforeLock = new WeakMap();
const lock = value => {
  const controls = [...document.querySelectorAll('[data-cart-payment-variant], [data-pawty-edit-personalization], cart-quantity-selector-component input, cart-quantity-selector-component button, .cart-items__remove'), ...checkout()];
  controls.forEach(el => {
    if (value) { disabledBeforeLock.set(el, el.disabled); el.disabled = true; }
    else if (disabledBeforeLock.has(el)) { el.disabled = disabledBeforeLock.get(el); disabledBeforeLock.delete(el); }
  });
  checkout().forEach(el => el.setAttribute('aria-disabled', String(value)));
};
document.addEventListener('click', event => { if (busy && event.target.closest('[name="checkout"], [href$="/checkout"]')) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
document.addEventListener('change', async event => {
  const input = event.target.closest('[data-cart-payment-variant]');
  if (!input || busy) return;
  const group = input.closest('[data-cart-payment]');
  if (input.value === group.dataset.currentVariant) return;
  busy = true; window.PawtyCartMutation = true; lock(true);
  const status = group.querySelector('[data-cart-payment-status]');
  status.textContent = group.dataset.savingLabel;
  let operation = null;
  try {
    await window.PawtyPricingRequest;
    const cart = await request('cart.js');
    const current = cart.items.find(item => item.key === group.dataset.lineKey);
    if (!current) throw new Error('Cart item changed');
    const product = await request(`products/${encodeURIComponent(current.handle)}.js`);
    const target = product.variants.find(variant => String(variant.id) === input.value && variant.available);
    if (!target || !/-(START|FULL)$/.test(target.sku || '')) throw new Error('Payment option unavailable');
    const properties = { ...(current.properties || {}), Payment: /-FULL$/.test(target.sku) ? 'Paid in full — priority production' : 'Start payment — balance after proof approval', '_Original variant ID': String(target.id), '_Customization ID': current.properties?.['_Customization ID'] || crypto.randomUUID() };
    operation = { oldKey: current.key, oldVariant: current.variant_id, oldSignature: signature(current.properties), oldCustomId: current.properties?.['_Customization ID'], newVariant: target.id, customId: properties['_Customization ID'] };
    sessionStorage.setItem('pawty-payment-pending', JSON.stringify(operation));
    const existing = cart.items.find(item => item.variant_id === target.id && item.properties?.['_Customization ID'] === operation.customId);
    if (!existing) await request('cart/add.js', { items: [{ id: target.id, quantity: current.quantity, properties }] });
    const refreshed = await request('cart.js');
    const original = refreshed.items.find(item => originalLine(item, operation));
    if (!original) throw new Error('Original cart item could not be identified');
    if (original.quantity !== current.quantity) throw new Error('Cart quantity changed');
    const updated = await request('cart/change.js', { line: refreshed.items.indexOf(original) + 1, quantity: 0 });
    if (updated.items.some(item => originalLine(item, operation)) || !updated.items.some(item => item.variant_id === operation.newVariant && item.properties?.['_Customization ID'] === operation.customId && item.quantity === current.quantity)) throw new Error('Payment replacement was not confirmed');
    sessionStorage.removeItem('pawty-payment-pending');
    location.assign(`${root}cart`);
  } catch (error) {
    console.warn('[pawty-payment-choice]', error.message);
    let safe = !operation;
    if (operation) {
      try {
        const cart = await request('cart.js');
        const old = cart.items.find(item => originalLine(item, operation));
        const added = cart.items.find(item => item.variant_id === operation.newVariant && item.properties?.['_Customization ID'] === operation.customId);
        if (old && added) await request('cart/change.js', { line: cart.items.indexOf(added) + 1, quantity: 0 });
        safe = true;
        sessionStorage.removeItem('pawty-payment-pending');
        if (!old && added) { location.assign(`${root}cart`); return; }
      } catch (_) {}
    }
    status.textContent = safe ? group.dataset.errorLabel : group.dataset.conflictLabel;
    group.querySelectorAll('input').forEach(el => { el.checked = el.value === group.dataset.currentVariant; });
    if (safe) { busy = false; window.PawtyCartMutation = false; lock(false); }
  }
});
async function recover() {
  let operation;
  try { operation = JSON.parse(sessionStorage.getItem('pawty-payment-pending') || 'null'); } catch (_) { return; }
  if (!operation) return;
  busy = true; window.PawtyCartMutation = true; lock(true);
  try {
    const cart = await request('cart.js');
    const old = cart.items.find(item => originalLine(item, operation));
    const added = cart.items.find(item => item.variant_id === operation.newVariant && item.properties?.['_Customization ID'] === operation.customId);
    if (old && added) await request('cart/change.js', { line: cart.items.indexOf(added) + 1, quantity: 0 });
    sessionStorage.removeItem('pawty-payment-pending');
    if (old && added) location.assign(`${root}cart`);
    else { busy = false; window.PawtyCartMutation = false; lock(false); }
  } catch (_) { document.querySelectorAll('[data-cart-payment-status]').forEach(el => { el.textContent = el.closest('[data-cart-payment]').dataset.conflictLabel; }); }
}
recover();
